<template>
    <div class="grid-container content-padding">
        <div class="grid-x" v-cloak>
            <div class="cell">
                <h1>Privacy Tools</h1>
            </div>
            <div class="cell" v-if="user">
                <p>Hi {{ user.name }}! From here, you can access and download to all your stored data or delete all of the data tied to your account.</p>
                <div class="grid-x grid-margin-x">
                    <a @click.prevent="downloadData" class="cell shrink button" :disabled="hasDownloadedData">Download your data</a>
                    <a @click.prevent="anonymizeData" class="cell shrink button ghost" :disabled="hasDeletedData">Delete your account</a>
                </div>
                <alert v-if="message" :type="privacyAlertType" :title="privacyRequestTitle">{{ message }}</alert>
            </div>
            <div class="cell" v-else>
                <p class="">Please identify yourself via e-mail.</p>
                <text-input v-if="!success" type="email" :value="email" @change="email = $event" label="Enter your e-mail"></text-input>
                <alert class="alert" v-if="message" :type="privacyAlertType" :title="privacyRequestTitle">{{ message }}</alert>
                <a class="button" @click.prevent="sendData" :disabled="hasRequestedData">Request access to your data</a>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import UserModule from '@/stores/modules/user';
import TextInput from '@/components/common/forms/TextInput.vue';
import Alert from '@/components/common/ui/Alert.vue';
import { AlertType } from '@/utils/types';
import api, { APIError } from '../../models/api';
import User from '../../models/user';

type TokenQueryParams = {
	token: string;
	user: string;
};

@Component({components: { TextInput, Alert }})
export default class PrivacyTool extends Vue
{
    userModule!: UserModule;
    user: User | null | any = null;
    email: string = '';
    success: boolean = false;
    message: string = '';
    displayUser: boolean = false;
    hasDownloadedData: boolean = false;
    hasDeletedData: boolean = false;
    hasRequestedData: boolean = false;

    created() {
        this.userModule = getModule(UserModule, this.$store);
    }

    async mounted() {
        if (this.userModule.currentUser) {
            this.user = this.userModule.currentUser;
        } else {
            const response = await this.requestExist(<TokenQueryParams>this.$route.query);
            if (response) {
                this.user = response;
            }
        }
    }
    public async requestExist(query: TokenQueryParams) {
        if (query.token && query.user) {
            return await api.post({name: 'gdpr.check'}, {token: query.token, email: query.user});
        }
    }

    public async sendData()  {
        this.hasRequestedData = true;
        const response = await api.post<{message: string}>({name: 'gdpr.request'}, {email: this.email});
        this.success = response.success;
        this.message = response.content.message;
        this.hasRequestedData = false;
    }

    public async downloadData() {
        this.hasDownloadedData = true;
        const response = await api.post<{message: string}>({name: 'gdpr.send'}, <TokenQueryParams>this.$route.query);
        this.success = response.success;
        this.message = response.content.message;
        this.hasDownloadedData = false;
    }

    public async anonymizeData() {
        this.hasDeletedData = true;
        const response = await api.post<{message: string}>({name: 'gdpr.anonymize'}, <TokenQueryParams>this.$route.query);
        this.success = response.success;
        this.message = response.content.message;
        this.hasDeletedData = false;
        if (this.success) {
            window.setTimeout(() => {
                this.userModule.logout();
            }, 2 * 1000);
        }
    }

    get privacyAlertType() {
        return (this.success) ? AlertType.SUCCESS : AlertType.ERROR;
    }

    get privacyRequestTitle() {
        return (this.success) ? "Request successful" : "Something went wrong";
    }
}
</script>
<style lang="scss" scoped>
.alert {
    margin-bottom: 20px;
}
</style>
